import config from './config';

config.init().then(() => {
  import('./init/main');
});
